import { create } from "zustand";
import { persist } from "zustand/middleware";

import { withUserNameFields } from "../utils/userIdentity";

interface UserState {
  user: any | null;
  loading: boolean;
  error: string | null;
  setUser: (user: any) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  logout: () => void;
  loadUserFromStorage: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: null,
      loading: false,
      error: null,
      // `/login` y `/auth/register` responden `firstName`/`lastName`; `/user`
      // responde `first_name`/`last_name`. Todo el front lee la forma snake,
      // así que se completa aquí, en la única puerta de entrada.
      setUser: (user) => set({ user: withUserNameFields(user) }),
      setLoading: (loading) => set({ loading }),
      setError: (error) => set({ error }),
      logout: () => set({ user: null }),
      loadUserFromStorage: () => {
        const storedUser = localStorage.getItem("user-storage");
        if (storedUser) {
          try {
            const parsed = JSON.parse(storedUser);
            if (parsed.state?.user) {
              set({ user: withUserNameFields(parsed.state.user) });
            }
          } catch (error) {
            console.error("Error loading user from storage:", error);
          }
        }
      },
    }),
    {
      name: "user-storage",
      partialize: (state) => ({ user: state.user }),
      // Sesiones ya guardadas antes de este arreglo (p. ej. un alta reciente,
      // que dejó sólo `firstName`/`lastName`) se corrigen al recargar.
      merge: (persisted, current) => {
        const saved = (persisted ?? {}) as Partial<UserState>;
        return { ...current, ...saved, user: withUserNameFields(saved.user ?? current.user) };
      },
    }
  )
);
